// Deps
import Swiper, { Navigation, Pagination } from 'swiper';
import _ from 'lodash';

/**
 * Tweets Swiper
 * ------------------------------------------------------- *
 */

// eslint-disable-next-line camelcase
const tweets_swiper = ( function( document ) {
	var activeFull = false;
	var activeTablet = false;

	var verticalOptions = {
		autoHeight: false,
		loop: true,
		direction: 'vertical',
		mousewheelControl: true,
		slidesPerView: 5,
		navigation: {
			nextEl: '.trigger-down',
			prevEl: '.trigger-up'
		}
	};

	var options = {
		autoHeight: true,
		loop: true,
		pagination: {
			clickable: true,
			el: '.swiper-pagination',
			type: 'bullets'
		}
	};

	var selector = '.tweets';
	var swiperButtonUp = '.swiper-button .up';
	var swiperButtonDown = '.swiper-button .down';

	var swiperButtonUpTrigger = '.trigger-up';
	var swiperButtonDownTrigger =  '.trigger-down';

	var element;
	var swiper;

	const _instance = {};

	function update() {
		var breakpoint = window.matchMedia( '(min-width: 60em)' ).matches;

		if ( breakpoint  && ! activeFull ) {
			destroy();
			addClassNames();
			launch( verticalOptions );
			activeFull = true;
		}

		if ( ! breakpoint  && ! activeTablet ) {
			destroy();
			addClassNames();
			launch( options );
			activeTablet = true;
		}
	}

	function removeClassNames() {
		var wrapper = element.querySelector( '.tweets__wrapper' );
		var items = element.querySelectorAll( '.tweets__slide' );
		element.classList.remove( 'swiper-container' );
		element.classList.remove( 'wiper-container-vertical' );

		wrapper.classList.remove( 'swiper-wrapper' );

		[].forEach.call( items, function( item ) {
			item.classList.remove( 'swiper-slide' );
		});
	}

	function addClassNames() {
		var wrapper = element.querySelector( '.tweets__wrapper' );
		var items = element.querySelectorAll( '.tweets__slide' );
		element.classList.add( 'swiper-container' );

		wrapper.classList.add( 'swiper-wrapper' );

		[].forEach.call( items, function( item ) {
			item.classList.add( 'swiper-slide' );
		});
	}

	function launch( settings ) {
		console.log( settings );
		swiper = new Swiper( selector, settings );
	}

	function destroy() {
		removeClassNames();

		if ( swiper ) {
			swiper.destroy();
		}

		activeFull = false;
		activeTablet = false;
		swiper = null;
	}

	function swiperButton( ) {
		var buttonUp = document.querySelector( swiperButtonUp );
		var buttonDown = document.querySelector( swiperButtonDown );

		buttonUp.addEventListener( 'click', function( event ) {
			event.preventDefault();
			element.querySelector( swiperButtonUpTrigger ).click();
		});

		buttonDown.addEventListener( 'click', function( event ) {
			event.preventDefault();
			element.querySelector( swiperButtonDownTrigger ).click();
		});
	}

	function init() {
		element = document.querySelector( selector );

		if ( ! element ) {
			return;
		}

		swiperButton();

		update();

		window.addEventListener( 'resize', _.throttle( update, 200 ) );
	}

	/**
	 * Public
	 */
	_instance.init = function() {
		init();
	};

	return _instance;
}( document ) );

// eslint-disable-next-line camelcase
export default tweets_swiper;
